//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { mapState } from 'vuex';
  import { formatDate, formatPrice } from '@/helpers/filters.js';
  export default {
    props: ['resource'],
    async fetch() {
      await Promise.all([
        this.$store.dispatch(
          'subscriptionsStore/getSubscriptions',
          this.queries.subscriptions
          ),
        this.$store.dispatch(
          'subscriptionsStore/getCreditbundles',
          this.queries.creditbundles
          ),
      ]);
    },
    components: {
      payPerMinute: () => import('~/components/payment/ppm.vue'),
      payPerMobile: () => import('~/components/payment/call_now.vue'),
      payPerMobilePincode: () =>
      import('~/components/payment/mobile_pincode.vue'),
      bancontact: () => import('@/assets/svg/bancontact.svg'),
      account: () => import('~/components/user/account_modal.vue'),
      pincode: () => import('~/components/user/pincode.vue'),
      newCode: () => import('~/components/user/new_code.vue'),
    },
    computed: {
      ...mapState({
        ppmStatus: ({ ppmStore: { ppmStatus } }) => ppmStatus,
        status: ({ paywallStore: { status } }) => status,
        account: ({ paywallStore: { account } }) => account,
        activeDeal: ({ subscriptionsStore: { activeDeal } }) => activeDeal,
        queries: ({ subscriptionsStore: { queries } }) => queries,
        subscriptions: ({ subscriptionsStore: { subscriptions } }) =>
        subscriptions,
        subscription: ({ subscriptionsStore: { subscription } }) => subscription,
        subscription_detail: ({ subscriptionsStore: { subscription_detail } }) =>
        subscription_detail,
        creditbundles: ({ subscriptionsStore: { creditbundles } }) =>
        creditbundles,
        creditbundle: ({ subscriptionsStore: { creditbundle } }) => creditbundle,
        product_to_pay: ({ subscriptionsStore: { product_to_pay } }) =>
        product_to_pay,
        coupon: ({ subscriptionsStore: { coupon } }) => coupon,
        episode: ({ resourcesStore: { episode } }) => episode,
        fullPincode: ({ accountStore: { fullPincode } }) => fullPincode,
      }),
      welkomCoupon() {
        if (
          this.product_to_pay &&
          this.product_to_pay.sales &&
          this.product_to_pay.sales.data
          ) {
          return this.product_to_pay.sales.data.find(
            (item) => item.slug === 'welkom-bij-direct' && item.coupon
            );
      }
      return null;
    },
  },
  watch: {
    '$auth.loggedIn'(newVal, oldVal) {
      if (!oldVal && newVal) {
        if (this.status.step === 3) {
          this.$store.commit('paywallStore/setStep', 4);
        }
      }
    },
    'status.view': function (newVal, oldVal) {
      if (oldVal === 'active' && newVal === 'closed') {
        this.$store.commit('paywallStore/resetPaywall');
      }
    },
    'status.step': function (newVal, oldVal) {
      if (newVal === 3 && oldVal === 4 && this.$auth.loggedIn) {
        this.$store.commit('paywallStore/setStep', 2);
      }
      if (newVal === 3 && oldVal === 2 && this.$auth.loggedIn) {
        this.$store.commit('paywallStore/setStep', 4);
      }
      if (newVal === 4) {
        document.body.classList.add('scroll-off');
      } else {
        document.body.classList.remove('scroll-off');
      }
    },
    'coupon.active': function (newVal, oldVal) {
      this.$forceUpdate();
    },
    coupon: function (newVal, oldVal) {
      this.$forceUpdate();
    },
    subscriptions: function (newVal, oldVal) {
      // This sets the most attractive subscription active
      if (
        this.subscriptions &&
        this.subscriptions.data &&
        this.subscriptions.data.length
        ) {
        // Find the subscription detail with the slug "direct-abonnement"
        const detail = this.subscriptions.data[0].details.data.find(
          (item) => item.slug === 'direct-abonnement'
          );
        // Check if the detail was found, then set it as active
      if (detail) {
        this.$store.commit(
          'subscriptionsStore/setSubscription',
          this.subscriptions.data[0]
          );
        this.$store.commit(
          'subscriptionsStore/setSubscriptionDetail',
          detail
          );
      }
    }
  },

  subscription: function (newVal, oldVal) {
    console.log(111);
    if (newVal.name === 'subscription') {
      this.dataSet = newVal.details.data;
      const detail = this.dataSet.find(
        (item) => item.slug === 'direct-abonnement'
        );
      this.$store.commit('subscriptionsStore/setProductToPay', detail);
    } else {
      this.dataSet = this.creditbundles.data;
      if (this.creditbundles.data.length) {
        this.$store.commit(
          'subscriptionsStore/setProductToPay',
          this.creditbundles.data[1]
          );
      }
    }
  },
},
data() {
  return {
    errors: {},
    dataSet: null,
    coupontext: '',
    showExtraDetails: false,
    registered: false,
    terms: false,
    complete: false,
    user: {
      email: '',
      newsletter: false,
      password: '',
      password_repeat: '',
    },
  };
},
async mounted() {
  var usermail = this.getCookie('usermail');
  if (usermail && !this.user.email) {
    this.user.email = usermail;
  }
  try {
    await this.$recaptcha.init();
  } catch (e) {
    console.error(e);
  }
},
methods: {
  formatDate,
  formatPrice,
  continueAccount() {
    if (!this.account) {
      this.sendEmailCheck();
    }
    if (this.account === 'login') {
      this.loginWithPassword();
    }
    if (this.account === 'pincode') {
      this.loginWithPin();
    }
    if (this.account === 'register') {
      this.register();
    }
  },
},
beforeDestroy() {
  this.$store.commit('paywallStore/resetPaywall');
},
};
